//react
import * as React from 'react';

//components
import LeadImage from '../components/LeadImage.jsx';

//images
import sustainability from '../assets/img/sections/sustainability.jpeg';

const Sustainability = () => {
  return (
    <section className="section" id="sustainability">
      <div className="wrapper" id="sustainability-wrapper">
        <LeadImage
          image={sustainability}
          text={
            'Solar panels were installed on Regents Drive Garage in 2017. (Photo courtesy of Andrew Muir)'
          }
        />

        <h1>Sustainability</h1>
        <h3 className="first-line">
          The city of College Park and the University of Maryland have several
          sustainability initiatives in the works, from adding solar panels to
          city buildings to getting every school associated with the city
          involved with “green” projects.
        </h3>
        <p>
          Most recently, College Park and WMATA have been working out an
          agreement for a community garden that “should be finalized in the
          coming weeks,” according to a city document. And the city’s Department
          of Public Works this month installed square pizza box receptacles at
          two locations downtown, which had been in the works since last year.
          This was to stop the overflowing of the boxes, which do not fit in the
          circle shaped recycle bins across the city.
          <br />
          <br />
          “A simple fix over the course of a year is going to save hundreds of
          boxes out of the landfills,” said rising senior government and
          politics major Jonathan Glaser, who was behind the idea of adding the
          pizza box recycle bins to the city.
          <br />
          <br />
          Glaser said both this university and College Park “are doing exactly
          what they should be doing” when it comes to sustainable initiatives.
          Yet former College Park Mayor Andrew Fellows, who was also the past
          chair of the city’s sustainability committee, said that environmental
          endeavors were not the original priority of the Vision 2020 plan.
          <br />
          <br />
          “As we came up with the vision, we realized we probably weren’t going
          to prioritize stuff equally,” Fellows said. “I somewhat consciously
          said, ‘This isn’t going to be the leading effort.’”
        </p>

        <h3 className="list-heading">Accomplisments to Date</h3>

        <p className="p-heading">
          College Park is a certified Maryland Sustainable Community
        </p>
        <p className="descrip">
          College Park achieved this certification, renewable for up to three
          years, in 2013. In 2016, the city became recertified.
          <br /> <br />
          To be granted certification, towns must pass a resolution stating
          their intent to become certified. Then, they must register online at
          this university’s Environmental Finance Center’s “Sustainable
          Maryland” website. Next, they select what actions they will take part
          in, create and designate a green team governed by the town to be in
          charge of these efforts and finally, submit an application for
          certification on the website.
          <br />
          <br />
          Each action taken is associated with a number of points earned. To
          become certified, towns need to earn at least 150 points. In 2013,
          College Park earned 190 points. In 2016, the city improved to 250
          points.
          <br />
          <br />
          Possible actions towns can take include creating a local food fair,
          building community gardens, creating a climate action plan,
          implementing a workplace wellness program and developing a pet waste
          education program.
          <br />
          <br />
          Actions College Park specifically took include: establishing local
          farmers markets, building community gardens and hosting local food
          cooking and preservation classes.
        </p>

        <p className="p-heading">
          The city and university are implementing “green” projects to increase
          residential energy efficiency, reduce stormwater pollution, plant
          trees, increase use of local food and much more.
        </p>
        <p className="descrip">
          College Park has reduced municipal electricity consumption by more
          than 20 percent since 2013. It has replaced about 200 lights in the
          downtown parking garage with LED lighting, which saves 50 percent in
          electricity consumption.
          <br /> <br />
          The city also installed solar panels on top of its Youth, Family and
          Senior Services Building and Public Works Repair Garage and is on
          track to meet the goal of producing 20 percent of municipal energy
          needs from on-site renewable energy. It cost about $70,000 each to
          install solar panels on the buildings, which were funded by grants
          from the Maryland Energy Administration.
          <br />
          <br />
          Since 2013, the city has sponsored rain barrel workshops, and for the
          past year it’s sold low-cost food compost bins to residents. It also
          provides pet waste pickup stations in parks and along trails.
          <br />
          <br />
          College Park has been member of Tree City USA, a program recognizes
          cities that promote healthy tree management, for more than two
          decades. This university is part of Tree Campus USA, a similar program
          for colleges and universities. As of 2016, more than 26 percent of the
          campus is covered in trees.
          <br />
          <br />
          Two city-sponsored farmers markets promote local distributors.
          <br />
          <br />
          Several buildings at this university — including Cumberland Hall and
          the Edward St. John Learning and Teaching Center — have green roofs,
          which host plants, reduce stormwater runoff and filter out rain-borne
          pollutants.
          <br />
          <br />
          This university has an initiative called the Partnership for Action
          Learning in Sustainability, which partnered with the city of College
          Park in 2015 to address sustainability challenges. Students in
          specific classes have helped multiple areas and counties in Maryland.
          Past College Park projects included recommendations for reducing solid
          waste and increasing recycling and plans for the development of a
          greenhouse gas inventory.
        </p>

        <p className="p-heading">
          A solar co-op forum was held to explore solar energy options for city
          residents with the City Committee for a Better Environment
        </p>
        <p className="descrip">
          The last forum was in 2016, and about 20 to 30 people signed up for
          solar energy at the meeting.
          <br /> <br />
          Solar energy options for city residents include joining a co-op (where
          a group of people share the cost together), purchasing individual
          solar panels and forming a power purchase agreement with a contractor
          (where the homeowner signs a lease for the contractor to buy, install
          and maintain the panels).
          <br />
          <br />
          “We’d like to do another one soon, maybe another one later this summer
          or early fall,” said Steve Beavers, the city’s community development
          coordinator.
        </p>

        <h3 className="list-heading">
          Highlights of the Sustainability 2018 Work Plan
        </h3>
        <p className="p-heading">Composting</p>
        <p className="descrip">
          There are quarterly meetings about food waste composting. The city
          also sells composting bins — made of recycled material — that
          residents can purchase for $20 and non-residents for $40.
          <br />
          <br />
          “We are interested in doing [a food composting program], exploring
          different ways to make it possible, whether that would be household
          pickup or a centralized collection area, but we are not really ready
          to present anything yet,” Beavers said.
          <br /> <br />
          Students have been involved in this process, Beavers said. Students
          from ENSP400: Capstone in Environmental Science and Policy completed a
          project on food composting and gave a presentation on their fundings
          to city officials, recommending they continue to encourage backyard
          food scrap composting because it has the best cost/benefit
          proposition.
          <br />
          <br />
          College Park will also have a trial food waste compost available at
          the Hollywood Farmer’s market starting in July, said Valerie Woodall,
          the senior program associate for the College Park City-University
          Partnership.
        </p>

        <p className="p-heading">Community Gardens</p>
        <p className="descrip">
          Currently, the city has two community gardens — one in Old Town and
          one in Hollywood. Each plot in the garden is filled with a mix of
          compost and topsoil and is 4 feet wide and 10 feet long. Only
          residents of College Park can get a membership for a plot, which is
          $15 per year.
          <br /> <br />
          The Old Town garden has 40 plots, while the Hollywood garden has 14
          plots. It costs the city about $50 to build each plot. The money to
          build these community gardens comes from the city’s sustainability
          fund.
          <br />
          <br />
          “The latest city survey done had community gardens ranked very high in
          resident satisfaction,” Beavers said. “The best part for me is that
          the community gardens bring together a lot of types of people who
          normally wouldn’t interact. There are members who are students,
          faculty of the university, retirees, just people from all walks of
          life brought together by their common interest of gardening.”
          <br />
          <br />
          There is a plan to build a third community garden in Calvert Hills on
          Metro property, which would start out with about a dozen plots.
          However, before that can happen WMATA and College Park have to work
          out an agreement that would allow city employees and residents to
          enter the property.
          <br />
          <br />
          “It’s very close — I’d love to see it start this summer and I think we
          are almost there,” Beavers said. “They’ve been really open to idea of
          having garden there and it’s great to even be able to have this
          conversation with them.”
        </p>

        <p className="p-heading">
          Recycling Rates and County “Rain Check” Program
        </p>
        <p className="descrip">
          Assist the City and County with increasing recycling rates as well as
          homeowner participation in the County “Rain Check” program to install
          environmental site design and rain barrels at homes in the City of
          College Park. Partnership promoting.
          <br /> <br />
          As of a few months ago, 22 people in College Park had applied for the
          rain check rebate - a financial incentive program, which “provides
          eligible applicants the opportunity to receive a reimbursement for
          installing approved stormwater management practices,” according to the
          Chesapeake Bay Trust website.
          <br />
          <br />
          Funding, which is given through grants by the Chesapeake Bay Trust,
          consists of up to $4,000 for residential property owners and up to
          $20,000 for commercial properties.
          <br />
          <br />
          An event was held to educate residents about rain barrels, and in the
          summer of 2017, 105 rain barrels were sold at the County Rain Check
          rebate program. More than 50 people attended.
          <br />
          <br />
          “There were two events since we sold so many rain barrels, we extended
          the sale and held a second pick up that included a rain barrel
          installation demonstration,” Woodall said in an email. There will be a
          Sustainability Expo on July 14 where people can pick up more rain
          barrels.
        </p>

        <p className="p-heading">Clean Energy</p>
        <p className="descrip">
          The city currently purchases 100 percent renewable energy off-site
          from a regional contractor. On-site, it currently produces 10 percent
          of clean energy using the solar panels recently installed. The city is
          on track to meet the goal of producing 20 percent of municipal energy
          needs from on-site renewable energy by 2020.
          <br /> <br />
          “The challenge is that electricity is being purchased by individual
          account holders, every single household and business in College Park,”
          said Mark Stewart, sustainability manager for this university’s
          sustainability office. “More than 10,000 are unique Pepco accounts,
          and whereas each individual can choose to receive clean energy, there
          needs to be a way to provide it for all utility customers so every
          individual won’t have to take action.”
          <br />
          <br />
          Stewart, who is also one of the co-chairs of the city’s sustainability
          committee, said a possible way to increase renewable energy on-site is
          to create a large-scale renewable energy project on or off-site. This
          would generate electricity itself and help to offset non-renewable
          energy usage in College Park. The cost could be around $100,000 a year
          for the city.
          <br />
          <br />
          Currently, this university operates around 10,000 solar panels on
          campus buildings within the city, and the city operates about 200
          solar panels.
        </p>

        <p className="p-heading">Environmental Arts</p>
        <p className="descrip">
          Many signs across the campus highlight “green” projects, from the
          Community Learning Garden to the Maryland Educational Solar Array at
          the A.V. Williams building to the green roofs on top of Stamp Student
          Union’s Atrium and Prince George’s Room.
          <br /> <br />
          In College Park, there are signs for various stormwater treatment
          projects. The signs explain what stormwater treatment is and the
          environmental benefit of it. Each sign costs “a couple hundred bucks,”
          Beavers said.
          <br />
          <br />
          There are no specific plans as of now to add more markers around the
          city.
        </p>

        <p className="p-heading">Stormwater Management</p>
        <p className="descrip">
          Due to a stormwater permit reissued by Maryland's environment
          department, this university has had to make a lot of improvements,
          Stewart said. One project is a restoration to the Campus Creek behind
          Eppley Recreation Center, which will improve the flow of the stream.
          This project is funded from a 2014 grant from the Maryland Department
          of Natural Resources for about $1.5 million along with a $50,000 grant
          from the University Sustainability Fund. The next phase of the project
          involves construction that starts this summer and is supposed to end
          this fall.
          <br /> <br />
          The city took part in a few projects last year, including the
          construction of step pools that make the water flow into the pool and
          absorb into the ground in that area, along with gutters that go into a
          box that filters into soil. Both projects are covered by a grant from
          the Chesapeake Bay Trust.
          <br />
          <br />
          “We’d like to do more all over the city,” Beavers said. “Whenever we
          can find an opportunity to do stormwater treatment, we will. … It is
          really something we want to do because of the environmental benefit of
          it.”
        </p>

        <p className="p-heading">
          Increase participation in sustainability efforts at local schools and
          Green Schools Coordinator
        </p>
        <p className="descrip">
          “We need someone, or a group of people, to help all the school
          coordinators in … applying to be a green school and keeping that
          status,” Fellows said.
          <br /> <br />
          To become a green school, institutions must create a committee, have a
          school-wide celebration, have a minimum of 10 percent of teachers
          attend environmental education professional development, create online
          resources, add environmental issue instruction to the curriculum, have
          student-driven sustainability practices, have community partnerships
          and take some additional steps.
          <br />
          <br />
          One College Park school that has reached green school status is Paint
          Branch Elementary, which achieved it in 2016. This institution
          recycles 4,000 pounds of materials per year, has two outdoor
          classrooms and on average has eight no-waste lunch days — during which
          students are encouraged to pack lunches in reusable containers — each
          year. There are nine schools serving College Park students with this
          status and three without it.
          <br />
          <br />
          The William S. Schmidt Outdoor Education Center partnered with the
          city with the goal of having every school serving College Park
          students become a green school. The William S. Schmidt Outdoor
          Education Center, an organization providing resources for schools to
          become more environmentally friendly, partnered with the city with the
          goal of having every school serving College Park students become a
          green school.
          <br />
          <br />
          “This may include developing course credit, adding projects to the
          DoGood Challenge on campus, working with a UMD Honors team or UMD
          Scholars project,” according to the document.
          <br />
          <br />
          “We haven’t tried writing a paragraph saying what we are doing, but I
          think we can do that by the end of 2018, but we are not there yet,”
          Fellows said.
        </p>
      </div>
    </section>
  );
};

export default Sustainability;



// WEBPACK FOOTER //
// ./src/views/Sustainability.jsx